'use client';
import React, { useState, useEffect } from 'react';
import Image from 'next/image';

interface MenuItem {
  label: string;
  url: string;
}

interface SiteSettings {
  site_name?: string;
  site_email?: string;
  site_phone?: string;
  site_address?: string;
  site_logo?: string;
  social_facebook?: string;
  social_instagram?: string;
  social_linkedin?: string;
  social_twitter?: string;
  social_youtube?: string;
  social_tiktok?: string;
  social_snapchat?: string;
  site_whatsapp?: string;
}

/* ─── Brand SVG Icons ───────────────────────────────────────────────────────── */
const SOCIAL_CONFIG = [
  {
    key: 'social_facebook',
    label: 'Facebook',
    bg: '#1877F2',
    path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  },
  {
    key: 'social_instagram',
    label: 'Instagram',
    bg: 'linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
  },
  {
    key: 'social_linkedin',
    label: 'LinkedIn',
    bg: '#0A66C2',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
  {
    key: 'social_twitter',
    label: 'X / Twitter',
    bg: '#000000',
    path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  },
  {
    key: 'social_youtube',
    label: 'YouTube',
    bg: '#FF0000',
    path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
  {
    key: 'social_tiktok',
    label: 'TikTok',
    bg: '#010101',
    path: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  },
  {
    key: 'site_whatsapp',
    label: 'WhatsApp',
    bg: '#25D366',
    path: 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z',
  },
];

function SocialIcon({ config, href }: { config: (typeof SOCIAL_CONFIG)[0]; href: string }) {
  // WhatsApp needs tel: prefix if no http
  const finalHref =
    config.key === 'site_whatsapp' && !href.startsWith('http')
      ? `https://wa.me/${href.replace(/\D/g, '')}`
      : href;

  return (
    <a
      href={finalHref}
      target="_blank"
      rel="noopener noreferrer"
      title={config.label}
      className="w-8 h-8 rounded-full flex items-center justify-center hover:scale-110 hover:opacity-90 transition-all duration-200 shadow-sm"
      style={{ background: config.bg }}
    >
      <svg viewBox="0 0 24 24" width="14" height="14" fill="white">
        <path d={config.path} />
      </svg>
    </a>
  );
}

export default function Footer() {
  const [siteSettings, setSiteSettings] = useState<SiteSettings>({});
  const [quickLinks, setQuickLinks] = useState<MenuItem[]>([
    { label: 'HOME', url: 'https://plotae.com/' },
    { label: 'DATA INTELLIGENCE', url: 'https://digital.plotae.com/' },
    { label: 'DEAL SCORE', url: '/deal-score' },
    { label: 'ABOUT', url: 'https://plotae.com/about/' },
    { label: 'RESIDENTIAL PLOTS FOR SALE', url: 'https://plotae.com/property-type/residential/' },
    { label: 'COMMERCIAL PLOTS FOR SALE', url: 'https://plotae.com/property-type/commercial/' },
    { label: 'INDUSTRIAL PLOTS FOR SALE', url: 'https://plotae.com/property-type/industrial/' },
    { label: 'MIXED LAND FOR SALE', url: 'https://plotae.com/property-type/mixed/' },
    { label: 'ENQUIRY', url: 'https://plotae.com/inquiry-form/' },
    { label: 'INSIGHTS', url: '/insights' },
    { label: 'CONTACT', url: '/contact' },
  ]);
  const [areas1, setAreas1] = useState<MenuItem[]>([
    { label: 'JEBEL ALI HILLS', url: 'https://plotae.com/jebel-ali-hills/' },
    { label: 'BU KADRA MEYDAN', url: 'https://plotae.com/bu-kadra-meydan/' },
    { label: 'MAJAN', url: 'https://plotae.com/majan/' },
    { label: 'DOWN TOWN', url: 'https://plotae.com/down-town/' },
    { label: 'DUBAI LAND', url: 'https://plotae.com/dubai-land/' },
    { label: 'DUBAI PRODUCTION CITY', url: 'https://plotae.com/dubai-production-city/' },
    { label: 'MADINAT AL HIND', url: 'https://plotae.com/madinat-al-hind/' },
  ]);
  const [areas2, setAreas2] = useState<MenuItem[]>([
    { label: 'BUSINESS BAY', url: 'https://plotae.com/business-bay/' },
    { label: 'DUBAI SILICON OASIS', url: 'https://plotae.com/silicon-oasis/' },
    { label: 'WARSAN', url: 'https://plotae.com/warsan/' },
    { label: 'JUMEIRAH GARDEN CITY', url: 'https://plotae.com/jumeirah-garden/' },
    { label: 'DUBAI ISLANDS', url: 'https://plotae.com/dubai-islands/' },
    {
      label: 'JUMEIRAH VILLAGE CIRCLE (JVC)',
      url: 'https://plotae.com/jumeirah-village-circle-jvc/',
    },
    { label: 'DLRC', url: 'https://plotae.com/dlrc/' },
    { label: 'DUBAI SPORTS CITY', url: 'https://plotae.com/sports-city/' },
  ]);

  useEffect(() => {
    // Fetch settings (social, contact, logo)
    fetch('/api/settings')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data) setSiteSettings(data);
      })
      .catch(console.error);

    // Fetch menus
    fetch('/api/menus')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!Array.isArray(data)) return;
        const parse = (m: any) =>
          m?.items ? (typeof m.items === 'string' ? JSON.parse(m.items) : m.items) : null;

        const qm = parse(data.find((m: any) => m.name === 'footer-quick-links'));
        const a1 = parse(data.find((m: any) => m.name === 'footer-areas-1'));
        const a2 = parse(data.find((m: any) => m.name === 'footer-areas-2'));

        if (Array.isArray(qm) && qm.length) setQuickLinks(qm);
        if (Array.isArray(a1) && a1.length) setAreas1(a1);
        if (Array.isArray(a2) && a2.length) setAreas2(a2);
      })
      .catch(console.error);
  }, []);

  // Active social links
  const activeSocials = SOCIAL_CONFIG.filter((s) => !!(siteSettings as any)[s.key]);

  // Contact info — fall back to hardcoded defaults if not set in settings
  const phone = siteSettings.site_phone || '+971 50 112 0273';
  const email = siteSettings.site_email || 'contact@plotae.com';
  const address =
    siteSettings.site_address || 'Office 125A, Al Hanaa Centre, Mankhool Road, Dubai.';
  const logo = siteSettings.site_logo || '/uploads/Plotae-3.pdf-1.png';

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* ── Column 1: Logo, Contact & Social ── */}
          <div>
            <a href="/" className="block mb-6">
              <Image
                src={logo}
                alt="Plotae.com - Trusted gateway to verified lands"
                width={150}
                height={60}
                className="h-auto w-[150px]"
                unoptimized
              />
            </a>

            {/* Contact */}
            <div className="mb-6">
              <p className="text-[12px] font-bold text-[#1a1a1a] uppercase tracking-widest mb-3">
                CONTACT US
              </p>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-[13px] text-[#50514f]">
                  <svg
                    className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#017743]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <span>{address}</span>
                </li>
                <li className="flex items-center gap-2 text-[13px] text-[#50514f]">
                  <svg
                    className="w-4 h-4 flex-shrink-0 text-[#017743]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  <a
                    href={`tel:${phone.replace(/\s/g, '')}`}
                    className="hover:text-[#017743] transition-colors"
                  >
                    {phone}
                  </a>
                </li>
                <li className="flex items-center gap-2 text-[13px] text-[#50514f]">
                  <svg
                    className="w-4 h-4 flex-shrink-0 text-[#017743]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <a href={`mailto:${email}`} className="hover:text-[#017743] transition-colors">
                    {email}
                  </a>
                </li>
              </ul>
            </div>

            {/* Dynamic Social Icons */}
            {activeSocials.length > 0 ? (
              <div className="flex items-center flex-wrap gap-2">
                {activeSocials.map((s) => (
                  <SocialIcon key={s.key} config={s} href={(siteSettings as any)[s.key]} />
                ))}
              </div>
            ) : (
              /* Fallback hardcoded if nothing saved yet */
              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/profile.php?id=61576977760490"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-[#1877F2] rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                >
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/plotuae/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                  style={{
                    background:
                      'linear-gradient(135deg,#f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
                  }}
                >
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@Plotuae"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-[#FF0000] rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                >
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://linkedin.com/company/107672220/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-[#0A66C2] rounded-full flex items-center justify-center hover:opacity-80 transition-opacity"
                >
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            )}
          </div>

          {/* ── Column 2: Quick Links ── */}
          <div>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.url}
                    className="flex items-center gap-2 text-[12px] text-[#50514f] hover:text-[#017743] transition-colors uppercase tracking-wide"
                  >
                    <svg
                      className="w-2.5 h-2.5 text-[#017743]"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M9 5l7 7-7 7"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                      />
                    </svg>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Column 3: Areas 1 ── */}
          <div>
            <ul className="space-y-2">
              {areas1.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.url}
                    className="flex items-center gap-2 text-[12px] text-[#50514f] hover:text-[#017743] transition-colors uppercase tracking-wide"
                  >
                    <svg
                      className="w-2.5 h-2.5 text-[#017743]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Column 4: Areas 2 ── */}
          <div>
            <ul className="space-y-2">
              {areas2.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.url}
                    className="flex items-center gap-2 text-[12px] text-[#50514f] hover:text-[#017743] transition-colors uppercase tracking-wide"
                  >
                    <svg
                      className="w-2.5 h-2.5 text-[#017743]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-100 py-6">
        <div className="max-w-[1280px] mx-auto px-4 lg:px-6">
          <div className="flex flex-col gap-3">
            <p className="text-[12px] text-[#50514f]">
              &copy; Bigsoftx - All rights reserved /{' '}
              <a href="/privacy-policy" className="hover:text-[#017743] transition-colors">
                Privacy Policy
              </a>{' '}
              /{' '}
              <a href="/terms-and-conditions" className="hover:text-[#017743] transition-colors">
                Terms &amp; Conditions
              </a>
            </p>
            <p className="text-[12px] text-[#50514f] leading-relaxed">
              <strong>Disclaimer:</strong> The information provided on this website is collected
              from publicly available Dubai Land Department (DLD) Open Data sources. While we strive
              to ensure the accuracy and reliability of the data presented, we make no
              representations or warranties of any kind, express or implied, about the completeness,
              accuracy, reliability, suitability, or availability of this information.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
